module.exports = __webpack_public_path__ + "static/media/wood2.f97571f2.jpg";